'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$135(ps$82) {
  this.a6P = null;
  this.a6P = ps$82;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$135 as $c_Lmealorama_jsonCodecs$package$$anon$135 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$135.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$135;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$135() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$135 as $h_Lmealorama_jsonCodecs$package$$anon$135 };
$h_Lmealorama_jsonCodecs$package$$anon$135.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6P.a.length;
});
$p.g = (function(i) {
  return this.a6P.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$135 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$135, "mealorama.jsonCodecs$package$$anon$135", ({
  IL: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$135 as $d_Lmealorama_jsonCodecs$package$$anon$135 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$135.js.map
